
/**
 *@file collors.js
 *@author Kjetil Fossheim
 *
 * colors used in app and logo
 * @type {String}
 */

export const AAIconGreen = '#5FBB5A';

export const AAIconBlue = '#3079B6';

export const AAIconBrown = '#F0A00C';


//  ICON other

export const bacgroundC = '#ededed';
export const headerText = '#fffef9';
export const menuColor = '#f3f3f3';
export const footerColor = '#ededed';
export const listEle = '#ffff';

export const AAIconGreenLX = '#65C860';
export const AAIconGreenL = '#9DC69B';
export const AAIconGreenD = '#52A14E';
export const AAIconGreenDX = '#1E3B1D';

export const AAIconBlueLX = '#A9D8FF';
export const AAIconBlueL = '#6D9CC2';
export const AAIconBlueD = '#235783';
export const AAIconBlueDX = '#0E2436';

export const AAIconBrownLX = '#FFEDCC';
export const AAIconBrownL = '#F2BB55';
export const AAIconBrownD = '#BD7E09';
export const AAIconBrownDX = '#704B06';



// WEBPACK FOOTER //
// ./lib/colors.js